<template>
    <div class="main">
        <div style="width: 100%;background-color:white;">
            </br>
            <h4 style="color: #0c1059;margin-left: 6%;height: 25px;">防伪信息</h4>
            <div class="line"></div> <!-- 这里会显示一条直线 -->
            <div style="display: flex;margin-left: 6%;margin-right: 6%;height: 70px;align-items: center;">
                <span id="antiresult" v-text="antiresult"></span>
            </div>

            <div class="line"></div> <!-- 这里会显示一条直线 -->

            <h4 style="color: #0c1059;margin-left: 6%;height: 25px;margin-top: 10px;">商品信息</h4>
            <div class="line"></div> <!-- 这里会显示一条直线 -->

            <div style="display: flex;flex-direction: column;margin-left: 6%;margin-right: 6%;">
                <span style="margin-top: 8px;">产品名称：<span id="cpmc" v-text="cpmc"></span></span>
                <span style="margin-top: 8px;">发&ensp;货&ensp;地：欧洲</span>
                <span v-if="yn" style="margin-top: 8px;">规&#12288;&#12288;格：<span id="gg" v-text="gg"></span></span>
                <span style="margin-top: 8px;">运输方式：<span id="ysfs" v-text="ysfs"></span></span>
                <span style="margin-top: 8px;">贮藏方式：<span id="zcfs" v-text="zcfs"></span></span>
                <span style="margin-top: 8px;margin-bottom: 8px;">效&#12288;&#12288;期：<span id="bzq" v-text="bzq"></span></span>
            </div>
        </div>

        <br /><br />




        <div style="width:100%;background-color: white;height: 50%;">
            </br>
            <h4 style="color: #0c1059;margin-left: 6%;height: 25px;">产品图片</h4>
            <div class="line"></div> <!-- 这里会显示一条直线 -->
            <p style="text-align: center;" id="productImage" v-html="imgsrc">
            </p>

        </div>

        <div v-show="isShow">
            <div id="fixedBg"></div>
            <p class="loading_p" id="loadP">
                <img src="/static/images/loadding.gif" />
            </p>
        </div>
    </div>
</template>

<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>


<style scoped>
.line {
    border: solid;
    border-color: #e2e0e0;
    border-width: 0.2px;
    width: 100%;
    /* 设置线的长度 */
}
</style>

<script>
import { getAntiResult, getInfoByCode } from '../../api/api'
export default {
    data() {
        return {
            antiresult: null,
            codeInfo: null,
            cpmc: null,
            ysfs: null,
            bzq: null,
            gg: null,
            zcfs: null,
            imgsrc: null,
            isShow: false,
            yn:false
        }
    },
    methods: {
        getResult() {
            this.isShow = true
            const params = this.$route.query;
            const code = params.c;
            getAntiResult(code).then(res => {
                const data = res.data;
                if (data == null || data.code == "500") {
                    this.isShow = false
                    alert("防伪查询失败,请联系管理员");
                } else {
                    this.antiresult = data.message
                    if (data.code != "300106") {
                        getInfoByCode(code).then(res => {
                            console.log(res)
                            //10 爱他美    11辅食
                            if (res.data.data.labelId == 10) {
                                this.cpmc = "Aptamil Profutura婴幼儿白金液体奶";
                                this.ysfs="空运";
                                this.bzq = "见罐体，在最佳食用日期前使用";
                                this.yn=false
                                this.zcfs = "避光控温存储";
                                this.imgsrc = "<img src=\"/static/images/product1.png\" style=\"height: 230px;vertical-align: middle;\">";
                            } else {
                                this.yn=true
                                this.cpmc = "Mellin辅食鱼泥";
                                this.bzq = "见瓶盖，在最佳食用日期前使用";
                                this.gg = "2*80G/盒";
                                this.ysfs="控温运输";
                                this.zcfs = "干燥避光储存";
                                this.imgsrc = "<img src=\"/static/images/product2.png\" style=\"height: 230px;vertical-align: middle;\">";
                            }


                        }).catch(err => {
                            this.isShow = false
                            alert(err)
                        }
                        )

                    }


                }
                this.isShow = false
            }).catch(err =>
                alert("查询异常，请联系管理员")
            )

        }
    },
    created: function () {
        this.getResult()
    }
}
</script>


// WEBPACK FOOTER //
// src/components/CGTrading/Index.vue